import cookie from "./_cookie";
import app from "../_app";

const recent = document.querySelector('.js-get-recently');
const recentViewed = document.querySelector('.js-get-recently-viewed');

if (recent) {

    const prev = recentViewed.querySelector('.js-recently-slider-prev');
    const next = recentViewed.querySelector('.js-recently-slider-next');

    if(app.viewport.isEqualOrGreaterThan('lg')) {
        prev.classList.add('arrow-lg-none');
        next.classList.add('arrow-lg-none');
    }

    if(cookie.get('recently-viewed') !== null) {
        async function fetchProducts() {
            const currentProducts = cookie.get('recently-viewed').split(',');

            for (const currentProduct of currentProducts) {
                try {
                    const response = await fetch(`/products/${currentProduct}?section_id=product-block-by-id`);
                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const numberOfItems = doc.querySelector('.js-product-block');

                    recent.insertAdjacentHTML('beforeend', doc.querySelector('.js-product-data').innerHTML);
                } catch (error) {
                    console.error(error);
                }
            }
        }
        fetchProducts();
    } else {
        recentViewed.classList.add('d-none');
    }

    document.addEventListener('click', event => {
        const $slider = event.target.closest('.js-get-recently-viewed');

        if($slider) {
            const $prev = $slider.querySelector('.js-recently-slider-prev');
            const $next = $slider.querySelector('.js-recently-slider-next');
            const width = $slider.querySelector('.js-slider-track ').querySelector('div').clientWidth;

            $prev.addEventListener('click', () => {
                $slider.querySelector('.js-slider-track ').scrollLeft -= width;
            });
            $next.addEventListener('click', () => {
                $slider.querySelector('.js-slider-track ').scrollLeft += width;
            });
        }
    });


}

export const recentProducts = (newProduct, max, days) => {

    let currentProducts = cookie.get('recently-viewed');

    if (currentProducts && currentProducts !== ''){

        const products = currentProducts.split(',');
        var index = products.indexOf(newProduct);

        if (index !== -1) {
            products.splice(index, 1);
        }

        products.unshift(newProduct);
        products.slice(0, 10);
        cookie.set('recently-viewed', products, 14);

    } else {
        cookie.set('recently-viewed', newProduct, 14);
    }
}